import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { zodResolver } from "@hookform/resolvers/zod";
import { editProfileSchema, EditProfileSchemaType } from "../../schemas";
import { backend } from "../../services/backend";
import { userBackend } from "../../services";
import { UserPersonalData } from "../../types";
import { formatDateTimeStandard } from "../../utils";

const UserProfileWatch = (props: { data: UserPersonalData}) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch()

  const session = State.session;
  const values = props.data;

  if (!session) {
    return null
  }

  useEffect(() => {
    userBackend
           .getUserProfile(session.id)
           .then((res) => {
             if (res) {
               // Устанавливаем значения в форму
               dispatch(actions.currentUserProfile(res.data))
             } 
           })
           .catch((e) => {
             console.error("Ошибка загрузки данных пользователя:", e.message);
           });
  }, [session])

  return (
    <div className="form">
      <form className="fullPageForm columnCenter">
        <div className="panelInner">
          <div className="flex between inputRow">
            <div className="column50">
              <label>
                Имя
              </label>
              <div className="">
                <p className="valueText">{values?.first_name}</p>
              </div>
            </div>

            <div className="column50">
              <label>
                Фамилия
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.last_name || ""}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex between inputRow">
            <div className="column50">
              <label>
                Номер телефона (для связи)
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.phone || ""}</p>
                </div>
              </div>
            </div>

            <div className="column50">
              <label>
                Номер телефона (WhatsApp)
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.whatsapp || ""}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex between inputRow">
            <div className="column50">
              <label>
                Адрес электронной почты
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.email || ""}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex between inputRow">
            <div className="column50">
              <label>
                Telegram
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.telegram}</p>
                </div>
              </div>
            </div>

            <div className="column50">
              <label>
                Город
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.city}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex between inputRow">
            <div className="column50">
              <label>
                Дата принятия на работу
              </label>
              <div className="">
                <div className="">
                  <p className="valueText">{values?.employ_date ? formatDateTimeStandard(values?.employ_date) : ""}</p>
                </div>
              </div>
            </div>

            <div className="column50">
              <label>Дата увольнения</label>
              <div className="">
                <div className="">
                  <p className="valueText">
                    {values?.unemploy_date ? formatDateTimeStandard(values?.unemploy_date) :"Действующий"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserProfileWatch;
